import React from 'react';
import { Col as AntCol } from 'antd';

/**
 * Wrapper component for Ant Design Col (Column)
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Col functionality including responsive grid system (span, offset, push, pull).
 * 
 * @component
 * @example
 * import { Row, Col } from '../GeneralComponents/ui';
 * 
 * <Row>
 *   <Col span={12}>col-12</Col>
 *   <Col span={12}>col-12</Col>
 * </Row>
 * 
 * <Row>
 *   <Col span={8}>col-8</Col>
 *   <Col span={8} offset={8}>col-8 col-offset-8</Col>
 * </Row>
 * 
 * @see https://ant.design/components/grid/ - Ant Design Grid documentation
 */
const Col = (props) => {
  return <AntCol {...props} />;
};

export default Col;

